import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDiditSessionsService, updateUserInformationLevelOneKycService } from 'network/services/didit.service'
import { fetchUserInformation } from 'redux-thunk/thunk/user.thunk'

export const getDiditSessions = createAsyncThunk(
  'fetch/get-didit-sessions',
  async ({ verificationLevel, forceNew } = {}, thunkApi) => {
    try {
      return await getDiditSessionsService({ verificationLevel, forceNew })
    } catch (error) {
      const message = error?.[0]?.description || 'Failed to start verification'
      return thunkApi.rejectWithValue(message)
    }
  }
)

export const retryDiditSession = createAsyncThunk(
  'fetch/retry-didit-session',
  async (verificationLevel, thunkApi) => {
    try {
      return await getDiditSessionsService({ verificationLevel, forceNew: true })
    } catch (error) {
      const message = error?.[0]?.description || 'Failed to start verification'
      return thunkApi.rejectWithValue(message)
    }
  }
)

export const levelOneVerificationDetails = createAsyncThunk(
  'level-one-update',
  async ({ data, handleCloseAccordion }, thunkApi) => {
    try {
      const res = await updateUserInformationLevelOneKycService(data)
      handleCloseAccordion()
      thunkApi.dispatch(fetchUserInformation())
      return res
    } catch (error) {
      const message = error?.[0]?.description || 'Failed to submit KYC details'
      return thunkApi.rejectWithValue(message)
    }
  }
)